import React, { useState, useContext } from "react";
import InfoIcon from "../../../assets/icn/info.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useEffect } from "react";
import { ModalProvider } from "../../../contexts/StockPageModal";
import Image from "next/image";

import OverallCard from "../../../elements/HoldingsCards/OverallCard/OverallCard";
import FIICard from "../../../elements/HoldingsCards/FIICard/FIICard";
import DIICard from "../../../elements/HoldingsCards/DIICard/DIICard";
import PromotersCard from "../../../elements/HoldingsCards/PromotersCard/PromotersCard";
import PublicCard from "../../../elements/HoldingsCards/PublicCard/PublicCard";
import MFundCard from "../../../elements/HoldingsCards/MFundCard/MFundCard";
import { CardTitleBtnSmall } from "@/elements/Button/Button";
import axiosInterceptorInstance from "@/elements/axiosInterceptorInstance";

const modalData = [
    {
        heading: `Promoter - FII - ODI - Retails - DIIs`,
        details: `Apart from retail investors, a company’s shares are held by promoters, foreign & domestic institutions and mutual funds.`
    },
    {
        heading: `Promoter`,
        details: `Promoters are the ship captains and control the company’s direction. Promoter holdings reflects the trust and optimism it's promoters have in the company`
    }
];

function ShareHolding({ symbol, shareHoldingData, isPaidUserPage }) {
    const modal = useContext(ModalProvider);

    const [data, setData] = useState(shareHoldingData?.[0]?.quarter ? shareHoldingData : []);

    const [cardType, setCardType] = useState("Promoters");
    const [selectedDuration, setSelectedDuration] = useState("");

    useEffect(() => {
        setSelectedDuration(shareHoldingData?.[0]?.quarter);
    }, []);

    const openModalHandler = () => {
        modal.setTitle("Shareholdings Pattern");
        modal.setModalData(modalData);
        modal.setModal(true);
    };

    return (
        <div data-aos="xxxx-xx">
            <div className="relative " id="holdings">
                <div className="font-Inter text-sm lg:text-base text-black flex flex-row mx-4 mt-6 mb-4 font-semibold  md:mt-10">
                    <h2 className="mr-4 line-clamp-1">
                        Shareholdings Pattern {!isPaidUserPage && `for ${symbol} Share`}
                    </h2>
                    <button className="w-4 h-4 self-center" onClick={openModalHandler}>
                        <Image src={InfoIcon} alt="info" className="w-4 min-w-4 h-4 self-center" />
                    </button>
                </div>
                <div className="flex mb-1 flex-row">
                    <Swiper
                        autoHeight
                        spaceBetween={16}
                        slidesPerView={1.1}
                        breakpoints={{
                            546: {
                                slidesPerView: 2
                            }
                        }}
                    >
                        <SwiperSlide>
                            <div className="py-3 border border-[#E5E5E5] rounded-xl ml-4">
                                <div className="font-Inter flex flex-row justify-start overflow-x-auto no-scrollbar px-3 gap-2 lg:gap-3">
                                    {["Promoters", "FII", "DII", "Public", "Other"].map((ele, i) => (
                                        <CardTitleBtnSmall
                                            key={i}
                                            active={cardType === ele}
                                            text={ele}
                                            onClick={() => setCardType(ele)}
                                        />
                                    ))}
                                </div>
                                {cardType === "FII" && <FIICard data={data} number={1} />}
                                {cardType === "DII" && <DIICard data={data} number={1} />}
                                {cardType === "Promoters" && <PromotersCard data={data} number={2} />}
                                {cardType === "Public" && <PublicCard data={data} number={3} />}
                                {cardType === "Other" && <MFundCard data={data} number={4} />}
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="py-3 border border-[#E5E5E5] rounded-xl mr-4" id="overall-card">
                                <div className="font-Inter text-[12px] flex flex-row justify-start overflow-x-auto no-scrollbar px-3 gap-3">
                                    {data?.map((ele, i) => (
                                        <CardTitleBtnSmall
                                            key={i}
                                            active={selectedDuration === ele.quarter}
                                            text={ele.quarter}
                                            onClick={() => setSelectedDuration(ele.quarter)}
                                        />
                                    ))}
                                </div>
                                <OverallCard data={data} selectedDuration={selectedDuration} />
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
        </div>
    );
}

export default ShareHolding;
